export default __webpack_public_path__ + "static/gallery-6-658c95ec6ac63e3b388841fdca43166f.jpg";